export const permissions = {
  ADD_REMOVE_FROM_TEAM: "ADD_REMOVE_FROM_TEAM",
  APPROVE_DIFFERENT_REPORT_LEVEL: "APPROVE_DIFFERENT_REPORT_LEVEL",
  CREATE_JOB: "CREATE_JOB",
  DELETE_JOB: "DELETE_JOB",
  DELETE_IMPORTED_SAP_JOB: "DELETE_IMPORTED_SAP_JOB",
  EDIT_JOB: "EDIT_JOB",
  IMPORT_JOB_FROM_SAP: "IMPORT_JOB_FROM_SAP",
  GENERATE_AND_DOWNLOAD_REPORT: "GENERATE_AND_DOWNLOAD_REPORT",
  GOODWILL_DECISION: "GOODWILL_DECISION",
  LEVEL_1_REPORT_APPROVAL: "LEVEL_1_REPORT_APPROVAL",
  LEVEL_2_REPORT_APPROVAL: "LEVEL_2_REPORT_APPROVAL",
  LEVEL_3_RELEASE_FOR_INVESTIGATION: "LEVEL_3_RELEASE_FOR_INVESTIGATION",
  LEVEL_3_REPORT_APPROVAL: "LEVEL_3_REPORT_APPROVAL",
  LEVEL_4_RELEASE_FOR_INVESTIGATION: "LEVEL_4_RELEASE_FOR_INVESTIGATION",
  LEVEL_4_REPORT_APPROVAL: "LEVEL_4_REPORT_APPROVAL",
  LEVEL_1_REPORT_REOPEN: "LEVEL_1_REPORT_REOPEN",
  LEVEL_2_REPORT_REOPEN: "LEVEL_2_REPORT_REOPEN",
  LEVEL_3_REPORT_REOPEN: "LEVEL_3_REPORT_REOPEN",
  LEVEL_4_REPORT_REOPEN: "LEVEL_4_REPORT_REOPEN",
  PARTICIPATE_IN_CONVERSATION: "PARTICIPATE_IN_CONVERSATION",
  PRINT_INPUT_SHEETS: "PRINT_INPUT_SHEETS",
  REOPEN_REPORT: "REOPEN_REPORT",
  REQUEST_DIFFERENT_REPORT_LEVEL: "REQUEST_DIFFERENT_REPORT_LEVEL",
  REQUEST_FAILED_PARTS: "REQUEST_FAILED_PARTS",
  SHIP_FAILED_PARTS: "SHIP_FAILED_PARTS",
  TAG_INTEREST: "TAG_INTEREST",
  VIEW_CONVERSATION: "VIEW_CONVERSATION",
  VIEW_JOB: "VIEW_JOB",
  VIEW_LOG: "VIEW_LOG",
  WARRANTY_DECISION: "WARRANTY_DECISION",
  REQUEST_TECHNICAL_WARRANTY_DECISION: "REQUEST_TECHNICAL_WARRANTY_DECISION",
  DOWNLOAD_PICTURES: "DOWNLOAD_PICTURES",
  AMEND_APPROVED_TECHNICAL_DECISION: 'AMEND_APPROVED_TECHNICAL_DECISION',
  AMEND_APPROVED_COMMERCIAL_DECISION: 'AMEND_APPROVED_COMMERCIAL_DECISION',
  ADD_INITIAL_WARRANTY_CODE: 'ADD_INITIAL_WARRANTY_CODE',
  RECLASSIFY_TECHNICAL_WARRANTY_CATEGORY: 'RECLASSIFY_TECHNICAL_WARRANTY_CATEGORY',
  APPROVE_REPORT_LEVEL_4_DOWNGRADE: 'APPROVE_REPORT_LEVEL_4_DOWNGRADE',
  APPROVE_TECHNICAL_DECISION_LEVEL_4: 'APPROVE_TECHNICAL_DECISION_LEVEL_4',
};



// WEBPACK FOOTER //
// ./src/constants/permissions.js